import React from "react";
import { Stack } from "@mui/material";
import LogFormShell from "../../UI/LogFormShell";
import MedicationDetailCard from "./MedicationDetailCard";
import { getAdaptiveMedicationProfileConfig } from "./adaptiveMedicationProfileConfig";

const MedicationEditorSheet = ({
  open,
  onClose,
  title,
  subtitle,
  childName,
  child = null,
  draft,
  isEditing = false,
  onDraftChange,
  onSaveDraft,
  onClearDraft,
  providers = [],
  topContent = null,
  saveStatus = "idle",
  saveError = "",
  saveWarning = "",
}) => {
  const saveLockRef = React.useRef(false);
  const medicationProfileConfig = React.useMemo(
    () => getAdaptiveMedicationProfileConfig(child),
    [child]
  );
  const handleClose = () => {
    if (saveStatus === "saving" || saveStatus === "saved") return;
    onClearDraft?.();
    if (onClose !== onClearDraft) {
      onClose?.();
    }
  };
  const handleSave = async () => {
    if (saveLockRef.current || saveStatus === "saving" || saveStatus === "saved") return;
    saveLockRef.current = true;
    try {
      await onSaveDraft?.();
    } finally {
      saveLockRef.current = false;
    }
  };

  return (
    <LogFormShell
      open={open}
      onClose={handleClose}
      title={title || (isEditing ? medicationProfileConfig.editTitle : medicationProfileConfig.addTitle)}
      subtitle={subtitle || childName || ""}
      titleBadge={childName || undefined}
      compactTitle
      mobileBreakpoint="md"
      bodySx={{
        pt: 1.1,
        pb: 1.35,
        px: { xs: 1.1, sm: 2 },
      }}
      surfaceSx={{
        height: "min(92dvh, 92vh)",
        maxHeight: "min(92dvh, 92vh)",
      }}
    >
      <Stack spacing={1.15}>
        {topContent}
        <MedicationDetailCard
          entry={draft}
          index={0}
          onChange={onDraftChange}
          onRemove={handleClose}
          onSave={handleSave}
          title={isEditing ? medicationProfileConfig.editTitle : medicationProfileConfig.addTitle}
          subtitle={medicationProfileConfig.subtitle}
          copy={medicationProfileConfig}
          providers={providers}
          saveStatus={saveStatus}
          saveError={saveError}
          saveWarning={saveWarning}
        />
      </Stack>
    </LogFormShell>
  );
};

export default MedicationEditorSheet;
